import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";
import type { GetOrganisationUsersResponse } from "./getOrganisationUsers";

const endpoint = spellbook("/me/organisations/users").POST();

export type InviteUserReq = typeof endpoint.types.Req;

export async function inviteUser(req: InviteUserReq): Promise<GetOrganisationUsersResponse | null> {
    const call = createCall(endpoint, (request) => fetch(withAccountOrNetworkAuthHeaders(request)));

    try {
        return await call({ req });
    } catch {
        // Spellbook handles the toast and auth redirect; keep this direct caller quiet.
        return null;
    }
}
